import { InventoryPageHeader } from "~/routes";
import {
  AssetInsights,
  ExploreWorkspace,
  InfoBar,
  QueryResults,
  References,
  RelatedFindings,
  RelatedPolicies,
  SummaryData,
  VulnerabilityInsights,
} from "./components";
import { useFindingOnAsset } from "~/pages/findings/FindingOnAsset/hooks";
import { Loading } from "~/components/loading";
import { ErrorBoundary } from "~/components/error-boundary";
import { AssetRemediation } from "~/pages/findings/FindingOnAsset/components/AssetRemediation/AssetRemediation";
import { Grid } from "@mui/material";
import { OpenExceptions } from "~/components/app-search/OpenExceptions/OpenExceptions";
import { UiPage } from "~/operations";
import { useReportViewed } from "~/hooks/useReportViewed";
import { DetectedBy } from "~/components/vulnerabilities/DetectedBy/DetectedBy";

export function FindingOnAsset() {
  const {
    loadingFindingOnAsset,
    exceptionActions,
    refetchFindingOnAsset,
    asset,
    spaceScope,
    detectionSources,
  } = useFindingOnAsset();

  useReportViewed({
    page: UiPage.FindingOnAsset,
    pageLoaded: !loadingFindingOnAsset && asset !== undefined,
    assetMrn: asset?.mrn,
    spaceMrn: spaceScope?.mrn,
    tab: "",
  });

  return (
    <ErrorBoundary key="finding-on-asset">
      <InfoBar />

      {loadingFindingOnAsset && <Loading />}

      {!loadingFindingOnAsset && (
        <InventoryPageHeader>
          <Grid sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <OpenExceptions
              {...exceptionActions.openExceptions}
              refetchQueries={[refetchFindingOnAsset]}
            />
            <SummaryData />
            <DetectedBy
              detectedBy={detectionSources}
              widthOverride={{ xs: 12, md: 10 }}
            />
          </Grid>
          <AssetInsights />
          <VulnerabilityInsights />
          <AssetRemediation />
          <QueryResults />
          <RelatedPolicies />
          <RelatedFindings />
          <ExploreWorkspace />
          <References />
        </InventoryPageHeader>
      )}
    </ErrorBoundary>
  );
}
